import styled from 'styled-components'

import Typography from '@material-ui/core/Typography'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-areas:
    "profile personal"
    "empty   password";
  grid-template-columns: 1fr 3fr;
  gap: 16px;
`

export const GridProfileDetails = styled.div`
  grid-area: profile;
`

export const GridPersonalInformation = styled.div`
  grid-area: personal;
`

export const GridPassword = styled.div`
  grid-area: password;
`

export const CardTitle = styled(Typography)`
  font-weight: ${ fonts.fontWeight.bold };
`

export const UserProfilePicture = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;
  width: 8vw;
  aspect-ratio: 1 / 1;
  margin: 1rem;
  background: ${ colors.grey };
  color: ${ colors.black };
  font-weight: ${ fonts.fontWeight.bold };
  div {
    display: inherit;
    justify-content: inherit;
    align-items: inherit;
    margin: 1rem 0;
  }
`
